import { environment } from 'environments/environment'

/**
 * This is to inject copilot into Helios.
 */
export function loadCopilot(document: Document) {
  const id = 'cwan-gpt-copilot'
  // Prevent multiple creations of the script
  if (document.getElementById(id)) return
  const copilot = document.createElement('script')
  copilot.id = id
  copilot.src = environment.externalComponents.copilotUrl
  document.body.appendChild(copilot)
}

/**
 * Adds the copilot button (the `<cwan-copilot-webcomponent>` host) to the
 * given header container. Returns the created element so the caller can
 * pass it to `setupCopilotResizing` from `./copilot-resize`.
 */
export function addCopilotButton(
  container?: HTMLElement,
): HTMLElement | undefined {
  if (!container) return undefined
  const el = document.createElement('cwan-copilot-webcomponent')
  el.setAttribute('z-index', '100000')
  container.appendChild(el)
  return el
}
